<template>
  <div>
    <h3>Factures du client</h3>

    <div v-if="invoices.length > 0">
      <div class="panel panel-transparent">
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-hover table-condensed table-detailed table-borderless table-striped search-table" id="detailedTable">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Organisation</th>
                  <th>N° de facture</th>
                  <th>Montant</th>
                  <th>Compte spécial</th>
                  <th>Statut</th>
                  <!-- <th>Commande</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="invoice in this.invoices">
                  <item :invoice="invoice" :key="invoice.id"></item>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <hr>
      
      <div class="alert alert-info">
          <i class="fa fa-info-circle"></i> Aucune facture n'est encore disponible pour ce client
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>

<script type="text/babel">
import {mapState, mapActions} from "vuex"
import Item from "./Invoices/Item"

export default {
  name: "Invoices",

  data () {
    return {
      customer_id:this.$route.params.id,
    }
  },

  methods :{
    ...mapActions('invoices', ['fetchInvoices']),
  },

  computed:{
    ...mapState('invoices',['invoices']),
  },


  created () {
    this.fetchInvoices(this.customer_id)
  },

  components:{
    Item,
  },
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/Invoices.vue